module.exports = __webpack_public_path__ + "2fa2e370.svg";